import { render, staticRenderFns } from "./IconFileDoc.vue?vue&type=template&id=59515a00&"
import script from "./IconFileDoc.vue?vue&type=script&lang=js&"
export * from "./IconFileDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports